import 'mapbox-gl/dist/mapbox-gl.css'
import React from 'react'
import { AutoSizer } from 'react-virtualized'

import { FeatureCollection_TypeEnum } from 'src/api/gen/api'
import Choropleth, { useTooltip } from 'src/commons/graphs/Choropleth'
import { MapToolTip } from 'src/commons/graphs/utilsComponent'
import { IFeature } from 'src/commons/types'
import { formatNumber } from 'src/commons/utils'

const getTooltip = (legendMap: string) => (properties: { label: string; percentage: number; value: number }) =>
  (
    <MapToolTip title={properties.label}>
      {legendMap}: {`${formatNumber(properties.value)} (${formatNumber(properties.percentage)}%)`}
    </MapToolTip>
  )

interface IKpiMapProps {
  data?: {
    features: IFeature[]
    type: string
  }
  legend: string
  title?: string
  tooltipLegend: string
}

function KpiMap(props: IKpiMapProps) {
  const [onHover, renderTooltip] = useTooltip(getTooltip(props.tooltipLegend))
  const values =
    props.data && props.data.features && props.data.features.length > 0
      ? props.data.features.map((feat: IFeature): number => feat.properties.value)
      : [1, 100]
  const valueSum = values.reduce((a, b) => a + b)
  // we don't want to color areas that have 0 vehicles deployed
  const filteredValues = values.filter((value) => value > 0)
  const min = filteredValues.length > 0 ? Math.min(...filteredValues) : 1
  const max = filteredValues.length > 0 ? Math.max(...filteredValues) : 100

  let filteredData: IKpiMapProps['data'] = { features: [], type: FeatureCollection_TypeEnum.FeatureCollection }
  if (props.data && props.data.features) {
    filteredData = {
      features: props.data.features.filter((feature: IFeature) => feature.properties.value > 0),
      type: props.data.type,
    }
    filteredData.features.forEach(
      (feature) => (feature.properties.percentage = Math.round((feature.properties.value / valueSum) * 100))
    )
  }

  return (
    <div style={{ flex: 1, textAlign: 'left', height: 700 }}>
      <AutoSizer>
        {({ height, width }) => (
          <Choropleth
            data={filteredData}
            onHover={onHover}
            scale={[min, max]}
            colorScale={['lightblue', 'darkblue']}
            renderTooltip={renderTooltip}
            width={width}
            height={height}
            legend={props.legend}
          />
        )}
      </AutoSizer>
    </div>
  )
}

export default KpiMap
